// extracted by mini-css-extract-plugin
export var locationCard = "_pw-0";